export const KEYBOARD_ENTER_KEY = 'Enter';
export const KEYBOARD_SPACE_KEY = ' ';
export const KEYBOARD_ACTIVATION_KEYS = new Set([KEYBOARD_ENTER_KEY, KEYBOARD_SPACE_KEY]);

export const KEYBOARD_HOME_KEY = 'Home';
export const KEYBOARD_END_KEY = 'End';
export const KEYBOARD_ARROW_LEFT_KEY = 'ArrowLeft';
export const KEYBOARD_ARROW_RIGHT_KEY = 'ArrowRight';
export const KEYBOARD_ARROW_UP_KEY = 'ArrowUp';
export const KEYBOARD_ARROW_DOWN_KEY = 'ArrowDown';

export type KeyboardNavigationOrientation = 'horizontal' | 'vertical' | 'both';

interface KeyboardNavigationIndexParams {
  currentIndex: number;
  itemCount: number;
  key: string;
  loop?: boolean;
  orientation?: KeyboardNavigationOrientation;
}

export const isKeyboardActivationKey = (key: string) => KEYBOARD_ACTIVATION_KEYS.has(key);

const isPreviousKeyboardNavigationKey = (key: string, orientation: KeyboardNavigationOrientation) => (
  ((orientation === 'horizontal' || orientation === 'both') && key === KEYBOARD_ARROW_LEFT_KEY)
  || ((orientation === 'vertical' || orientation === 'both') && key === KEYBOARD_ARROW_UP_KEY)
);

const isNextKeyboardNavigationKey = (key: string, orientation: KeyboardNavigationOrientation) => (
  ((orientation === 'horizontal' || orientation === 'both') && key === KEYBOARD_ARROW_RIGHT_KEY)
  || ((orientation === 'vertical' || orientation === 'both') && key === KEYBOARD_ARROW_DOWN_KEY)
);

export const getKeyboardNavigationIndex = ({
  currentIndex,
  itemCount,
  key,
  loop = true,
  orientation = 'both',
}: KeyboardNavigationIndexParams) => {
  if (itemCount === 0) {
    return -1;
  }

  if (isPreviousKeyboardNavigationKey(key, orientation)) {
    if (currentIndex <= 0) {
      return loop ? itemCount - 1 : -1;
    }

    return currentIndex - 1;
  }

  if (isNextKeyboardNavigationKey(key, orientation)) {
    if (currentIndex >= itemCount - 1) {
      return loop ? 0 : -1;
    }

    return currentIndex + 1;
  }

  if (key === KEYBOARD_HOME_KEY) {
    return 0;
  }

  if (key === KEYBOARD_END_KEY) {
    return itemCount - 1;
  }

  return -1;
};
